import styled from 'styled-components'

export const DialogIcon = styled.img`
  height: 64px;
  margin-bottom: 30px;
  width: 64px;
`

export const ErrorMessage = styled.p`
  color: ${props => props.theme.palette.brand.error};
  font-size: 14px;
  margin: 0 0 20px;
  text-align: center;
`

export const Strong = styled.span`
  font-weight: bold;
`
